var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { styled } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Filter, Filters } from '@hn-ui/filters';
import { Add } from '@hn-ui/icons';
import { BlueButton } from '@hn-ui/buttons';
import { useAssignmentsList } from '../../hooks/useAssignmentsList';
import { HowItWork } from './components/HowItWork';
import { AssignmentsListHeader } from './components/Header';
import { AssignmentsTableFilters, DEFAULT_TABLE_FILTER, LabelByAssignmentsFilter, } from '../../constants/filters';
import { AssignmentsTable } from './components/AssignmentsTable';
import { ASSIGNMENTS_API, ASSIGNMENTS_ROUTES } from '../../constants/routes';
import { AssignmentsListPreloader } from './components/Preloader';
import { useAppGoogleAnalytics } from '../../../../../shared_app/hooks/useAppGoogleAnalytics';
import { ASSIGNMENTS_EVENTS, ASSIGNMENTS_EVENT_CATEGORIES, } from '../../constants/analytics';
import { InviteColleaguesAssessmentModal } from './components/InviteColleaguesAssessmentModal';
import { buildURI, useToggle } from '@hn-front/utils';
import { usePostEvent } from '../../../Common/hooks/usePostEvent';
import { UpgradePremiumAssessmentModal } from './components/UpgradePremiumAssessmentModal';
var Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-17lizp7" })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var FiltersWrapper = styled.div.withConfig({ displayName: "FiltersWrapper", componentId: "sc-1k1pbp1" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n"])));
var ScAddBtn = styled(BlueButton).withConfig({ displayName: "ScAddBtn", componentId: "sc-1s3bc2c" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 174px;\n  gap: 4px;\n"], ["\n  width: 174px;\n  gap: 4px;\n"])));
var AddAssignmentButton = function (_a) {
    var onClick = _a.onClick;
    return (_jsxs(ScAddBtn, __assign({ size: 'small', onClick: onClick }, { children: [_jsx(Add, { color: 'black100', size: 16 }, void 0), _jsx("span", { children: "Add assignment" }, void 0)] }), void 0));
};
var ScBtnWrapper = styled.div.withConfig({ displayName: "ScBtnWrapper", componentId: "sc-7xcb0o" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin-top: 40px;\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-top: 40px;\n"])));
var EventsByFilter = (_a = {
        All: ASSIGNMENTS_EVENTS.assign_default_page_filterall_click
    },
    _a["Ended" /* Ended */] = ASSIGNMENTS_EVENTS.assign_default_page_filter_completed_click,
    _a["Active" /* Active */] = ASSIGNMENTS_EVENTS.assign_default_page_filter_inprogress_click,
    _a["Scheduled" /* Scheduled */] = ASSIGNMENTS_EVENTS.assign_default_page_filter_scheduled_click,
    _a);
var AssignmentsList = function (_a) {
    var groupId = _a.groupId, lockReason = _a.lockReason, allowAssignments = _a.allowAssignments, wayToObtainAccess = _a.wayToObtainAccess;
    var _b = useState({
        allowAssignments: allowAssignments,
        wayToObtainAccess: wayToObtainAccess,
    }), assignmentRestriction = _b[0], setAssignmentRestriction = _b[1];
    var assignments = useAssignmentsList(groupId).response;
    var _c = useState(DEFAULT_TABLE_FILTER), chosenFilter = _c[0], setFilter = _c[1];
    var ga = useAppGoogleAnalytics();
    var handleFilterChange = useCallback(function (value) {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage,
            action: EventsByFilter[value],
        });
        setFilter(value);
    }, [ga]);
    var _d = useToggle(), isInviteColleaguesModal = _d.isToggled, toggleInviteColleaguesModal = _d.toggle;
    var navigate = useNavigate();
    var revalidateGroupInfo = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, fetch(buildURI(ASSIGNMENTS_API.groupInfo, { pathParams: { groupId: groupId } }), { headers: { 'Content-Type': 'application/json' } })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = (_c.sent()).data;
                    setAssignmentRestriction({
                        allowAssignments: (_a = data.assignments) === null || _a === void 0 ? void 0 : _a.allowAssignments,
                        wayToObtainAccess: (_b = data.assignments) === null || _b === void 0 ? void 0 : _b.wayToObtainAccess,
                    });
                    return [2 /*return*/, data];
            }
        });
    }); }, []);
    var handleOnClick = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, revalidateGroupInfo()];
                case 1:
                    data = _c.sent();
                    if (!((_a = data.assignments) === null || _a === void 0 ? void 0 : _a.allowAssignments)) {
                        postEvent('assignment_limit_reached').then();
                        if (((_b = data.assignments) === null || _b === void 0 ? void 0 : _b.wayToObtainAccess) === 'premium')
                            toggleUpgradePremiumModal();
                        else
                            toggleInviteColleaguesModal();
                        return [2 /*return*/];
                    }
                    ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
                        category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage,
                        action: ASSIGNMENTS_EVENTS.assign_default_page_addnew_click,
                    });
                    window.scrollTo({ top: 0 });
                    navigate(ASSIGNMENTS_ROUTES.createAssignment);
                    return [2 /*return*/];
            }
        });
    }); }, [ga, navigate]);
    var handleOnPremium = useCallback(function () {
        document.location.href = '/pricing';
    }, []);
    var postEvent = usePostEvent()[0];
    var handleOnInvite = useCallback(function () {
        postEvent('invite_colleagues_no_addons', { type: 'assignments' }).then(function () {
            document.location.href = '/teachers/boarding';
        });
    }, []);
    var _e = useToggle(), isUpgradePremiumModal = _e.isToggled, toggleUpgradePremiumModal = _e.toggle;
    var handleOnReassign = useCallback(function (assignmentId) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, revalidateGroupInfo()];
                case 1:
                    data = _c.sent();
                    if (!((_a = data.assignments) === null || _a === void 0 ? void 0 : _a.allowAssignments)) {
                        if (((_b = data.assignments) === null || _b === void 0 ? void 0 : _b.wayToObtainAccess) === 'premium')
                            toggleUpgradePremiumModal();
                        else
                            toggleInviteColleaguesModal();
                        return [2 /*return*/];
                    }
                    ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
                        category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentsListPage,
                        action: ASSIGNMENTS_EVENTS.assign_default_page_reassign_click,
                    });
                    navigate(buildURI(ASSIGNMENTS_ROUTES.createAssignmentFromAnother, {
                        pathParams: { assignmentId: assignmentId },
                    }));
                    return [2 /*return*/];
            }
        });
    }); }, [ga, groupId, navigate]);
    if (!assignments)
        return _jsx(AssignmentsListPreloader, {}, void 0);
    return (_jsxs(Wrapper, __assign({ "data-testid": 'assignments-list' }, { children: [assignments.length ? (_jsxs(_Fragment, { children: [_jsx(AssignmentsListHeader, { lockReason: lockReason, wayToObtainAccess: assignmentRestriction.wayToObtainAccess }, void 0), _jsxs(FiltersWrapper, __assign({ "data-testid": 'assignments-list-filters' }, { children: [_jsx(Filters, __assign({ value: chosenFilter !== null && chosenFilter !== void 0 ? chosenFilter : DEFAULT_TABLE_FILTER, onChange: handleFilterChange }, { children: AssignmentsTableFilters.map(function (name) { return (_jsx(Filter, { value: name, label: LabelByAssignmentsFilter[name], primary: name === DEFAULT_TABLE_FILTER }, name)); }) }), void 0), _jsx(AddAssignmentButton, { onClick: handleOnClick }, void 0)] }), void 0), _jsx(AssignmentsTable, { groupId: groupId, assignments: assignments, filter: chosenFilter === DEFAULT_TABLE_FILTER ? undefined : chosenFilter, onReassign: handleOnReassign, wayToObtainAccess: assignmentRestriction.wayToObtainAccess }, void 0)] }, void 0)) : (_jsx(HowItWork, { allowAssignments: assignmentRestriction.allowAssignments, wayToObtainAccess: assignmentRestriction.wayToObtainAccess }, void 0)), _jsx(ScBtnWrapper, { children: _jsx(AddAssignmentButton, { onClick: handleOnClick }, void 0) }, void 0), _jsx(InviteColleaguesAssessmentModal, { open: isInviteColleaguesModal, onClose: toggleInviteColleaguesModal, onInvite: handleOnInvite, onPremium: handleOnPremium }, void 0), _jsx(UpgradePremiumAssessmentModal, { open: isUpgradePremiumModal, onClose: toggleUpgradePremiumModal, onPremium: handleOnPremium }, void 0)] }), void 0));
};
export { AssignmentsList };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
